export default __webpack_public_path__ + "static/Resources-498363cbc933bc035fdaf8344df399d4.png";